import { noticeFailure } from "@self/notices";
import { makeStylesheetLink } from "../stylesheet";

export class SortDropdown extends HTMLElement {
	shadow: ShadowRoot;
	select: HTMLSelectElement;

	onSortChange: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.select = <select id="sort-dropdown">
			<option value="default">Featured</option>
			<option value="price-asc">Price, low to high</option>
			<option value="price-desc">Price, high to low</option>
		</select> as HTMLSelectElement;

		this.onSortChange = onSortChange.bind(this);

		this.shadow.append(
			this.select,
			makeStylesheetLink()
		);

	}

	connectedCallback() {
		this.select.addEventListener("change", this.onSortChange.bind(this));
	}

	disconnectedCallback() {
		this.select.removeEventListener("change", this.onSortChange.bind(this));
	}
}

async function onSortChange(this: SortDropdown) {
	const selectedValue = this.select.value;

	const currentUrl = new URL(this.dataset.url!);

	if (selectedValue) {
		currentUrl.searchParams.set("orderby", selectedValue);
	} else {
		currentUrl.searchParams.delete("orderby");
	}

	console.log(currentUrl);

	try {
		const response = await fetch(currentUrl.toString());
		if (!response.ok) {
			noticeFailure("There was an unexpected error.");
			return;
		}

		const html = await response.text();
		const doc = new DOMParser().parseFromString(html, "text/html");

		const newContent = doc.getElementById("product-loop-archive");
		const oldContent = document.getElementById("product-loop-archive");

		if (newContent && oldContent) {
			oldContent.innerHTML = newContent.innerHTML;
		}

		const viewMoreButton = document.querySelector("gct-view-more");
		if (viewMoreButton) {

			if (parseInt(viewMoreButton.getAttribute("data-page")?? "1") > 1) {
				viewMoreButton.setAttribute("data-page", "1");
				const button = viewMoreButton.shadowRoot?.getElementById("view-more-products");
				if (button) button.style.display = "flex";
			}

		}
	} catch (error) {
		noticeFailure("There was an unexpected error.");
	}
}
